import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["bankName"];
  showDirectDebit(event) {
    event.preventDefault();

    if ($(".show-ezidebit-account").length == 0) {
      const url = this.data.get("url");
      showDirectDebitDetailsHtml(url);
    }
  }

  authoriseDirectDebit(event) {
    event.preventDefault();

    const authoriseUrl = this.data.get("authoriseUrl");
    const url = this.data.get("url");
    const fromDashboard = this.data.get("from-dashboard");

    axios({
      method: "patch",
      url: authoriseUrl,
      responseType: "json"
    })
      .then(response => {
        this.displayDirectDebit(url, fromDashboard);
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  newDirectDebit(event) {
    event.preventDefault();

    const url = this.data.get("url");

    this.displayDirectDebit(url);
  }

  editDirectDebit(event) {
    event.preventDefault();

    const url = this.data.get("url");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".account-direct-debit-container").innerHTML =
          html;
        applyBrandStyles();
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  cancelDirectDebit(event) {
    event.preventDefault();

    const url = this.data.get("url"),
      redirectUrl = this.data.get("redirectUrl"),
      authenticityToken = this.data.get("authenticityToken"),
      message = this.data.get("message");

    bootbox.confirm({
      title: "Cancel Direct Debit",
      message: message,
      callback: function (result) {
        if (result) {
          axios({
            method: "patch",
            url: url,
            data: { authenticity_token: authenticityToken },
            responseType: "json"
          })
            .then(response => {
              showNotification("success", response.data.message);

              showDirectDebitDetailsHtml(redirectUrl);
              $(".iframe-spinner-container").hide();
            })
            .catch(error => {
              hideModal("#modal-spinner-modal");
              showErrorMessage(error);
            });
        }
      },
      buttons: {
        confirm: {
          label: "YES",
          className: "btn-warning"
        },
        cancel: {
          label: "NO",
          className: "btn-standard"
        }
      }
    });
  }

  bsbValidation(event) {
    const bsb_code = event.target.value;

    if (bsb_code) {
      this.bankNameTarget.value = "";
      axios
        .get(`/payments/bsb/${bsb_code}.json`, {
          headers: {
            Accept: "Application/json"
          }
        })
        .then(response => {
          if (response.data.length > 0) {
            const bsb_res = response.data[0];
            this.bankNameTarget.value = `${bsb_res.bankcode} - ${bsb_res.name}`;
          } else {
            bootbox.alert({
              className: "failure-modal",
              title:
                "<i class='fa fa-exclamation-triangle failed-icon'></i>Alert",
              message: this.defaultError(bsb_code),
              closeButton: false
            });
          }
        })
        .catch(error => {
          bootbox.alert({
            className: "failure-modal",
            title:
              "<i class='fa fa-exclamation-triangle failed-icon'></i>Alert",
            message: this.defaultError(bsb_code),
            closeButton: false
          });
        });
    }
  }

  defaultError(bsb_code) {
    return `<p>We are unable to match the BSB : ${bsb_code} with a Financial Institution.</p>Please review your BSB data entry or type in the Financial Institution manually.`;
  }

  displayDirectDebit(url, fromDashboard) {
    if (fromDashboard == "true") {
      window.location = url;
    } else {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.text();
        })
        .then(html => {
          document.querySelector(".account-direct-debit-container").innerHTML =
            html;
          applyBrandStyles();
        })
        .catch(error => {
          showErrorMessage(error);
        });
    }
  }

  remindDirectDebitSetup(event) {
    event.preventDefault();
    const url = `${this.data.get("url")}.json`;
    axios
      .post(
        url,
        {},
        {
          headers: {
            Accept: "Application/json",
            "X-CSRF-Token": document
              .getElementsByName("csrf-token")[0]
              .getAttribute("content")
          }
        }
      )
      .then(responseObj => {
        // triggered close from html
      })
      .catch(error => {});
  }
}
